<template>
  <div class="warning-list">
    <div class="table-shell">
      <table>
        <thead>
          <tr>
            <th>商品名称</th>
            <th>产地</th>
            <th>参考价</th>
            <th>现价</th>
            <th>变动幅度</th>
            <th>预警时间</th>
            <th>预警类型</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in rows" :key="row.name">
            <td>
              <span class="product-pill">{{ row.name }}</span>
            </td>
            <td>{{ row.origin }}</td>
            <td>{{ row.platform }}</td>
            <td class="price">{{ row.price }}</td>
            <td :class="['change', row.direction]">
              {{ row.direction === "up" ? "↑" : "↓" }} {{ row.change }}
            </td>
            <td>{{ row.time }}</td>
            <td class="type">{{ row.type }}</td>
          </tr>
        </tbody>
      </table>

      <!-- <div class="side-action">
        <i></i>
        <span>新增预警</span>
      </div> -->
    </div>

    <div class="rule-text">
      预警规则：涨价≥10% | 降价≥15% | 价差≥20% | 地标低价倾销
    </div>
  </div>
</template>

<script setup>
const rows = [
  { name: "邵店黄姜干货", origin: "邵店镇", platform: "31.90", price: "42.80", change: "34.2%", direction: "up", time: "14:20", type: "京东价差>20%" },
  { name: "菌菇礼盒", origin: "无量寺乡", platform: "65.80", price: "88.00", change: "33.7%", direction: "up", time: "14:18", type: "京东高于上限" },
  { name: "黄姜粉", origin: "邵店镇", platform: "28.40", price: "39.80", change: "40.1%", direction: "up", time: "14:16", type: "京东价差>20%" },
  { name: "红薯干", origin: "朱里镇", platform: "22.60", price: "16.80", change: "25.7%", direction: "down", time: "14:15", type: "本地接近下限" },
  { name: "朱里红薯粉条", origin: "朱里镇", platform: "33.60", price: "24.80", change: "26.2%", direction: "down", time: "14:12", type: "本地价差>20%" },
  { name: "小磨香油", origin: "蔡都街道", platform: "56.80", price: "43.60", change: "23.2%", direction: "down", time: "14:10", type: "本地低价倾销" },
];
</script>

<style lang="less" scoped>
.warning-list {
  height: 100%;
  padding: 12px 18px 14px;
  box-sizing: border-box;
  color: #dff6ff;
  overflow: hidden;
  background:
    radial-gradient(circle at 56% 0, rgba(34, 176, 255, 0.26), transparent 28%),
    linear-gradient(180deg, rgba(5, 32, 80, 0.2), rgba(3, 22, 58, 0.08));
}

.warning-top {
  height: 34px;
  position: relative;
}

.status-dots {
  position: absolute;
  left: 140px;
  top: 4px;
  display: flex;
  gap: 20px;
}

.status-dots span {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  display: block;
}

.status-dots .red {
  background: #ff5d79;
  box-shadow: 0 0 12px rgba(255, 93, 121, 0.9);
}

.status-dots .blue {
  background: #1fc5ff;
  box-shadow: 0 0 12px rgba(31, 197, 255, 0.95);
}

.rolling-tag {
  position: absolute;
  right: 6px;
  top: -2px;
  width: 118px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  color: #d9f8ff;
  font-size: 24px;
  background: linear-gradient(180deg, rgba(19, 89, 165, 0.72), rgba(7, 45, 108, 0.82));
  border: 1px solid rgba(52, 187, 255, 0.35);
  box-shadow: inset 0 0 12px rgba(37, 181, 255, 0.22);
}

.table-shell {
  height: calc(100% - 64px);
  // padding: 0 0 0 10px;
  box-sizing: border-box;
  position: relative;
}

table {
  width: 100%;
  height: 100%;
  border-collapse: separate;
  border-spacing: 0;
  table-layout: fixed;
  color: #d8f4ff;
  font-size: 22px;
  text-shadow: 0 0 8px rgba(73, 202, 255, 0.38);
  border: 1px solid rgba(38, 142, 235, 0.28);
  box-shadow:
    inset 0 0 24px rgba(28, 134, 242, 0.12),
    0 0 18px rgba(25, 148, 255, 0.16);
}

th {
  height: 50px;
  color: #e8fbff;
  font-weight: bold;
  background: linear-gradient(180deg, rgba(14, 94, 177, 0.95), rgba(7, 50, 115, 0.92));
  border-bottom: 1px solid rgba(62, 182, 255, 0.48);
}

td {
  height: 50px;
  text-align: center;
  font-weight: bold;
  background: rgba(5, 36, 91, 0.62);
  border-bottom: 1px solid rgba(40, 128, 222, 0.26);
}

tbody tr:nth-child(2n) td {
  background: rgba(4, 31, 78, 0.54);
}

tbody tr:hover td {
  background: rgba(17, 98, 170, 0.52);
}

th:first-child,
td:first-child {
  width: 185px;
}

th:nth-child(2),
td:nth-child(2) {
  width: 120px;
}

th:nth-child(3),
td:nth-child(3),
th:nth-child(4),
td:nth-child(4) {
  width: 110px;
}

th:nth-child(5),
td:nth-child(5) {
  width: 108px;
}

th:nth-child(6),
td:nth-child(6) {
  width: 110px;
}

.product-pill {
  width: 180px;
  height: 40px;
  line-height: 40px;
  display: inline-block;
  color: #fff;
  border-radius: 4px;
  background:
    linear-gradient(90deg, rgba(255, 255, 255, 0.32), transparent 18%, transparent 82%, rgba(255, 255, 255, 0.18)),
    linear-gradient(180deg, #1dd4ff 0%, #0784ef 52%, #0251b7 100%);
  box-shadow:
    inset 0 0 12px rgba(198, 247, 255, 0.72),
    0 0 12px rgba(12, 173, 255, 0.66);
}

.price {
  color: #83dcff;
  font-size: 26px;
}

.change {
  font-size: 26px;
}

.change.up {
  color: #9cefff;
}

.change.down {
  color: #7bd8ff;
}

.type {
  color: #bdefff;
}

.side-action {
  position: absolute;
  right: 5px;
  top: 0;
  width: 26px;
  height: 100%;
  border-radius: 14px;
  background: linear-gradient(180deg, #20d8ff 0%, #047ce5 38%, #03419c 100%);
  box-shadow:
    inset 0 0 12px rgba(202, 249, 255, 0.68),
    0 0 14px rgba(26, 183, 255, 0.68);
  display: flex;
  align-items: center;
  justify-content: center;
}

.side-action i {
  position: absolute;
  top: 9px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #dffcff;
  box-shadow: 0 0 10px #fff;
}

.side-action span {
  width: 16px;
  color: #eaffff;
  font-size: 26px;
  font-weight: bold;
  line-height: 16px;
  text-align: center;
  writing-mode: vertical-rl;
  letter-spacing: 2px;
}

.rule-text {
  height: 30px;
  line-height: 30px;
  margin-top: 30px;
  color: #e9fbff;
  font-size: 26px;
  text-align: center;
  text-shadow: 0 0 8px rgba(63, 206, 255, 0.65);
}
</style>
